// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spectrum--light .spectrum-Search-icon {\n  color: rgb(110, 110, 110);\n}\n.spectrum--light .spectrum-Search-input:disabled ~ .spectrum-Search-icon {\n      color: rgb(179, 179, 179);\n    }\n", ""]);
// Exports
module.exports = exports;
